var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-upload"},[_c('div',{staticClass:"avatar-preview"},[(_vm.coverImgUrl)?_c('div',{style:({
        backgroundImage: 'url(' + _vm.coverImgUrl + ')'
      })}):_c('div',[_c('i',{staticClass:"fs-12000 text-primary",class:_vm.fontAwClass})])])])}
var staticRenderFns = []

export { render, staticRenderFns }